import {
  useQuerySupportEligibility,
  useQueryZapierSession,
} from 'app/developer-v3/hooks';

const useEligibility = () => {
  const queryZapierSession = useQueryZapierSession();
  const querySupportEligibility = useQuerySupportEligibility();

  const isLoading =
    queryZapierSession.isLoading || querySupportEligibility.isLoading;

  const eligibility = isLoading
    ? {
        isEmailSupportEligible: undefined,
        isPremierSupportEligible: undefined,
      }
    : querySupportEligibility.data;

  return {
    isLoading,
    eligibility,
    error: queryZapierSession.error || querySupportEligibility.error,
  };
};

export default useEligibility;
